import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSplitTreatments } from '@splitsoftware/splitio-react';
import {
    FEATURE_FLAGS,
    getUserAttributes,
    getLeadFormComponent,
    LeadFormWizardCompletionContext,
    LeadFormData,
} from '@lendica/application-form';
import { baseURL, env } from '../api/axiosInstance';

export const SignupFlow = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // Get treatment for the lead form test
    const { treatments, isReady } = useSplitTreatments({
        names: [FEATURE_FLAGS.LEAD_FORM_TEST],
        attributes: getUserAttributes(),
    });

    useEffect(() => {
        if (isReady) {
            const treatment = treatments[FEATURE_FLAGS.LEAD_FORM_TEST];

            // Track variant shown for analytics if needed
            console.log('Lead form variant:', treatment.treatment);
        }
    }, [isReady, treatments]);

    // Show loading while Split is determining treatment
    if (!isReady) {
        return <div>Loading...</div>;
    }

    const treatment = treatments[FEATURE_FLAGS.LEAD_FORM_TEST];

    const handleLeadComplete = async (
        data: LeadFormData,
        context: LeadFormWizardCompletionContext
    ) => {
        // Navigate to create password flow
        const preservedParams = context.searchParams?.toString();
        const queryString = preservedParams ? `?${preservedParams}` : '';
        const variantQuery = context.variant
            ? `${queryString ? '&' : '?'}variant=${context.variant}`
            : '';
        navigate(`/signup/create-password${queryString}${variantQuery}`);
    };

    // Use the treatment mapping from the feature package
    const LeadFormComponent = getLeadFormComponent(treatment.treatment);

    // Pass searchParams, baseURL, and onComplete to the selected component
    return (
        <LeadFormComponent
            searchParams={searchParams}
            onComplete={handleLeadComplete}
            baseURL={baseURL}
            requirePhone={false}
            appType="dashboard"
            env={env}
        />
    );
};
